/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomerServiceLevel } from "./CustomerServiceLevel";
import {
  CustomerServiceLevelFromJSON,
  CustomerServiceLevelFromJSONTyped,
  CustomerServiceLevelToJSON,
  CustomerServiceLevelToJSONTyped,
} from "./CustomerServiceLevel";
import type { AccountSelectionStrategy } from "./AccountSelectionStrategy";
import {
  AccountSelectionStrategyFromJSON,
  AccountSelectionStrategyFromJSONTyped,
  AccountSelectionStrategyToJSON,
  AccountSelectionStrategyToJSONTyped,
} from "./AccountSelectionStrategy";
import type { BookShipmentStrategy } from "./BookShipmentStrategy";
import {
  BookShipmentStrategyFromJSON,
  BookShipmentStrategyFromJSONTyped,
  BookShipmentStrategyToJSON,
  BookShipmentStrategyToJSONTyped,
} from "./BookShipmentStrategy";
import type { DashboardTemperatureHandling } from "./DashboardTemperatureHandling";
import {
  DashboardTemperatureHandlingFromJSON,
  DashboardTemperatureHandlingFromJSONTyped,
  DashboardTemperatureHandlingToJSON,
  DashboardTemperatureHandlingToJSONTyped,
} from "./DashboardTemperatureHandling";
import type { QuotingStrategy } from "./QuotingStrategy";
import {
  QuotingStrategyFromJSON,
  QuotingStrategyFromJSONTyped,
  QuotingStrategyToJSON,
  QuotingStrategyToJSONTyped,
} from "./QuotingStrategy";
import type { EquipmentType } from "./EquipmentType";
import {
  EquipmentTypeFromJSON,
  EquipmentTypeFromJSONTyped,
  EquipmentTypeToJSON,
  EquipmentTypeToJSONTyped,
} from "./EquipmentType";

/**
 *
 * @export
 * @interface ServiceProperties
 */
export interface ServiceProperties {
  /**
   *
   * @type {string}
   * @memberof ServiceProperties
   */
  internalServiceDescription?: string | null;
  /**
   *
   * @type {CustomerServiceLevel}
   * @memberof ServiceProperties
   */
  customerServiceLevel: CustomerServiceLevel;
  /**
   *
   * @type {string}
   * @memberof ServiceProperties
   */
  carrierServiceName?: string | null;
  /**
   *
   * @type {QuotingStrategy}
   * @memberof ServiceProperties
   */
  quotingStrategy: QuotingStrategy;
  /**
   *
   * @type {object}
   * @memberof ServiceProperties
   */
  serviceArea: object;
  /**
   *
   * @type {BookShipmentStrategy}
   * @memberof ServiceProperties
   */
  bookShipmentStrategy: BookShipmentStrategy;
  /**
   *
   * @type {Array<DashboardTemperatureHandling>}
   * @memberof ServiceProperties
   */
  supportedTemperatureHandling: Array<DashboardTemperatureHandling>;
  /**
   *
   * @type {Array<EquipmentType>}
   * @memberof ServiceProperties
   */
  supportedEquipmentTypes: Array<EquipmentType>;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  supportsExclusiveUse: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  hasStagingEnvironment: boolean;
  /**
   *
   * @type {object}
   * @memberof ServiceProperties
   */
  handlingUnitLimits: object;
  /**
   *
   * @type {object}
   * @memberof ServiceProperties
   */
  overallLimits: object;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  supportsDangerousGoods: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  supportsTradeShows: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  supportsUNFI: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  allowsSameDayTransfers: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  northboundCrossBorderTransitTimesAreReliable: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  chargesTaxesOnInvoices?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  chargesTaxesOnQuotes?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ServiceProperties
   */
  flagged: boolean;
  /**
   *
   * @type {AccountSelectionStrategy}
   * @memberof ServiceProperties
   */
  accountSelectionStrategy: AccountSelectionStrategy;
}

/**
 * Check if a given object implements the ServiceProperties interface.
 */
export function instanceOfServiceProperties(
  value: object,
): value is ServiceProperties {
  if (
    !("customerServiceLevel" in value) ||
    value["customerServiceLevel"] === undefined
  )
    return false;
  if (!("quotingStrategy" in value) || value["quotingStrategy"] === undefined)
    return false;
  if (!("serviceArea" in value) || value["serviceArea"] === undefined)
    return false;
  if (
    !("bookShipmentStrategy" in value) ||
    value["bookShipmentStrategy"] === undefined
  )
    return false;
  if (
    !("supportedTemperatureHandling" in value) ||
    value["supportedTemperatureHandling"] === undefined
  )
    return false;
  if (
    !("supportedEquipmentTypes" in value) ||
    value["supportedEquipmentTypes"] === undefined
  )
    return false;
  if (
    !("supportsExclusiveUse" in value) ||
    value["supportsExclusiveUse"] === undefined
  )
    return false;
  if (
    !("hasStagingEnvironment" in value) ||
    value["hasStagingEnvironment"] === undefined
  )
    return false;
  if (
    !("handlingUnitLimits" in value) ||
    value["handlingUnitLimits"] === undefined
  )
    return false;
  if (!("overallLimits" in value) || value["overallLimits"] === undefined)
    return false;
  if (
    !("supportsDangerousGoods" in value) ||
    value["supportsDangerousGoods"] === undefined
  )
    return false;
  if (
    !("supportsTradeShows" in value) ||
    value["supportsTradeShows"] === undefined
  )
    return false;
  if (!("supportsUNFI" in value) || value["supportsUNFI"] === undefined)
    return false;
  if (
    !("allowsSameDayTransfers" in value) ||
    value["allowsSameDayTransfers"] === undefined
  )
    return false;
  if (
    !("northboundCrossBorderTransitTimesAreReliable" in value) ||
    value["northboundCrossBorderTransitTimesAreReliable"] === undefined
  )
    return false;
  if (!("flagged" in value) || value["flagged"] === undefined) return false;
  if (
    !("accountSelectionStrategy" in value) ||
    value["accountSelectionStrategy"] === undefined
  )
    return false;
  return true;
}

export function ServicePropertiesFromJSON(json: any): ServiceProperties {
  return ServicePropertiesFromJSONTyped(json, false);
}

export function ServicePropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceProperties {
  if (json == null) {
    return json;
  }
  return {
    internalServiceDescription:
      json["internalServiceDescription"] == null
        ? undefined
        : json["internalServiceDescription"],
    customerServiceLevel: CustomerServiceLevelFromJSON(
      json["customerServiceLevel"],
    ),
    carrierServiceName:
      json["carrierServiceName"] == null
        ? undefined
        : json["carrierServiceName"],
    quotingStrategy: QuotingStrategyFromJSON(json["quotingStrategy"]),
    serviceArea: json["serviceArea"],
    bookShipmentStrategy: BookShipmentStrategyFromJSON(
      json["bookShipmentStrategy"],
    ),
    supportedTemperatureHandling: (
      json["supportedTemperatureHandling"] as Array<any>
    ).map(DashboardTemperatureHandlingFromJSON),
    supportedEquipmentTypes: (
      json["supportedEquipmentTypes"] as Array<any>
    ).map(EquipmentTypeFromJSON),
    supportsExclusiveUse: json["supportsExclusiveUse"],
    hasStagingEnvironment: json["hasStagingEnvironment"],
    handlingUnitLimits: json["handlingUnitLimits"],
    overallLimits: json["overallLimits"],
    supportsDangerousGoods: json["supportsDangerousGoods"],
    supportsTradeShows: json["supportsTradeShows"],
    supportsUNFI: json["supportsUNFI"],
    allowsSameDayTransfers: json["allowsSameDayTransfers"],
    northboundCrossBorderTransitTimesAreReliable:
      json["northboundCrossBorderTransitTimesAreReliable"],
    chargesTaxesOnInvoices:
      json["chargesTaxesOnInvoices"] == null
        ? undefined
        : json["chargesTaxesOnInvoices"],
    chargesTaxesOnQuotes:
      json["chargesTaxesOnQuotes"] == null
        ? undefined
        : json["chargesTaxesOnQuotes"],
    flagged: json["flagged"],
    accountSelectionStrategy: AccountSelectionStrategyFromJSON(
      json["accountSelectionStrategy"],
    ),
  };
}

export function ServicePropertiesToJSON(json: any): ServiceProperties {
  return ServicePropertiesToJSONTyped(json, false);
}

export function ServicePropertiesToJSONTyped(
  value?: ServiceProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    internalServiceDescription: value["internalServiceDescription"],
    customerServiceLevel: CustomerServiceLevelToJSON(
      value["customerServiceLevel"],
    ),
    carrierServiceName: value["carrierServiceName"],
    quotingStrategy: QuotingStrategyToJSON(value["quotingStrategy"]),
    serviceArea: value["serviceArea"],
    bookShipmentStrategy: BookShipmentStrategyToJSON(
      value["bookShipmentStrategy"],
    ),
    supportedTemperatureHandling: (
      value["supportedTemperatureHandling"] as Array<any>
    ).map(DashboardTemperatureHandlingToJSON),
    supportedEquipmentTypes: (
      value["supportedEquipmentTypes"] as Array<any>
    ).map(EquipmentTypeToJSON),
    supportsExclusiveUse: value["supportsExclusiveUse"],
    hasStagingEnvironment: value["hasStagingEnvironment"],
    handlingUnitLimits: value["handlingUnitLimits"],
    overallLimits: value["overallLimits"],
    supportsDangerousGoods: value["supportsDangerousGoods"],
    supportsTradeShows: value["supportsTradeShows"],
    supportsUNFI: value["supportsUNFI"],
    allowsSameDayTransfers: value["allowsSameDayTransfers"],
    northboundCrossBorderTransitTimesAreReliable:
      value["northboundCrossBorderTransitTimesAreReliable"],
    chargesTaxesOnInvoices: value["chargesTaxesOnInvoices"],
    chargesTaxesOnQuotes: value["chargesTaxesOnQuotes"],
    flagged: value["flagged"],
    accountSelectionStrategy: AccountSelectionStrategyToJSON(
      value["accountSelectionStrategy"],
    ),
  };
}
